import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, FileText, Zap, MapPin } from 'lucide-react';
export function HeroSection() {
  return <section className="px-4 max-w-5xl mx-auto text-center pt-[10px] pb-[10px]" data-id="element-176">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="inline-flex items-center gap-2 bg-sky-900/30 text-sky-400 px-4 py-1.5 rounded-full font-medium border border-sky-500/20 text-[14px] pt-[4px] pb-[4px]" data-id="element-177">
        <span data-id="element-178">🧠</span> TU MANUAL DIGITAL™
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className="md:text-[108px] font-extrabold tracking-tight text-balance text-[32px] pt-[0px] pb-[0px] mt-[-4px] mb-[-4px]" data-id="element-179">
        Dejá de perder horas armando resúmenes.
      </motion.h1>

      <motion.h2 initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} className="md:text-[90px] font-black text-sky-500 -mt-2 md:-mt-4 text-[20px]" data-id="element-180">
        Todo resumido, explicado y listo para estudiar desde hoy.
      </motion.h2>

      <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={{
      duration: 0.7,
      delay: 0.25
    }} className="flex flex-col items-center justify-center my-2" data-id="element-181">
        <img src="https://cdn.magicpatterns.com/uploads/dPjXMpBzwSWMCvZFvNEBJy/Diseno_sin_titulo__7_-removebg-preview.png" alt="Megapack Psicología Lista - Mockup del producto" className="w-full max-w-md md:max-w-lg drop-shadow-[0_0_30px_rgba(14,165,233,0.2)] -my-16 md:-my-24 mt-[-100px] mb-[-100px]" data-id="element-182" />
        <p className="md:text-2xl text-gray-300 font-medium text-[16px]" data-id="element-183">
          El sistema N°1 para estudiantes de Psicología en Argentina
        </p>
        <p className="text-gray-400 text-[12px] mt-1" data-id="element-184">
          Resúmenes + simulacros + flashcards + mapas mentales — Sin perderte en
          la bibliografía
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="flex flex-wrap justify-center gap-2 md:gap-3 text-xs md:text-sm font-medium text-gray-300 py-6" data-id="element-185">
        <div className="flex items-center gap-1 bg-gray-800/50 px-2 py-1 rounded-md border border-gray-700 whitespace-nowrap" data-id="element-186">
          <FileText size={14} className="text-gray-400" data-id="element-187" /> 100% PDF
        </div>
        <div className="flex items-center gap-1 bg-gray-800/50 px-2 py-1 rounded-md border border-gray-700 whitespace-nowrap" data-id="element-188">
          <Zap size={14} className="text-yellow-400" data-id="element-189" /> Acceso en 5 min
        </div>
        <div className="flex items-center gap-1 bg-gray-800/50 px-2 py-1 rounded-md border border-gray-700 whitespace-nowrap" data-id="element-190">
          <MapPin size={14} className="text-sky-400" data-id="element-191" /> Hecho para Argentina
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.5
    }} className="flex flex-col items-center" data-id="element-192">
        <a href="#pricing" className="group relative inline-flex px-8 py-4 text-lg md:text-xl font-bold text-black bg-sky-500 rounded-xl overflow-hidden transition-all hover:scale-105 hover:bg-sky-400 shadow-[0_0_40px_rgba(14,165,233,0.4)] animate-pulse-slow w-full max-w-md items-center justify-center" data-id="element-193">
          <span className="relative z-10 flex gap-2 items-center justify-center" data-id="element-194">
            → QUIERO MI MEGAPACK AHORA
          </span>
          <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-195" />
        </a>

        <div className="flex flex-wrap justify-center gap-4 mt-6 text-sm text-gray-400" data-id="element-196">
          <span className="flex items-center gap-1.5" data-id="element-197">
            <Shield size={16} className="text-sky-500" data-id="element-198" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-199">
            <Lock size={16} className="text-sky-500" data-id="element-200" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-201">
            <CreditCard size={16} className="text-blue-400" data-id="element-202" /> Mercado Pago
          </span>
        </div>
      </motion.div>
    </section>;
}